import React from "react";
import {
  Autocomplete,
  Button,
  Grid,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import LogoutIcon from "@mui/icons-material/Logout";
import { Box } from "@mui/system";
import { styled, alpha, makeStyles } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../img/SFA.png";
import InputBase from "@mui/material/InputBase";
import { useSelector, useDispatch } from "react-redux";
import { setOpen, closeSidebar } from "./HeaderSlice";
import "./Header.css";
import Divider from "@mui/material/Divider";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import auth from "../../route/auth";
import { Avatar } from "@mui/material";
import "../../Responsive.css";
// const drawerWidth = 240;
import config from "../../config/config";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete";
import { useState } from "react";
import { useEffect } from "react";
import { useLocalStorage } from "../../Hooks/Index";
const UnderlineSpan = styled("span")({
  textDecoration: "underline",
  color: "#7DEF74",
  paddingLeft: "10px",
});

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "8px",
  backgroundColor: alpha(theme.palette.common.white, 1),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.9),
  },
  //   marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(2),
    width: "100%",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  //   pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  top: "0",
  right: "0",
  cursor: "pointer",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    // vertical padding + font size from searchIcon
    paddingRight: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const useLogout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    auth.logout(() => navigate("/login"));
    localStorage.clear();
    sessionStorage.clear();
  };

  return handleLogout;
};

const Header = () => {
  const open = useSelector((state) => state.HeaderSlice.value);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [siteList, setSiteList] = useLocalStorage("sites", []);
  const [selectedSite, setSelectedSite] = useLocalStorage("selectedSite", null);

  const skipPaths = ["/companywiseclient"];
  const currentPath = window.location.pathname;
  const shouldSkipByPath = skipPaths.some((path) => currentPath.includes(path));

  const handleLogout = () => {
    auth.logout(() => navigate("/login"));
    localStorage.clear();
    sessionStorage.clear();
  };
  const handleDrawerOpen = (event) => {
    // alert("hii");
    event.stopPropagation();
    dispatch(setOpen());
  };
  const handleDrawerClose = () => {
    dispatch(closeSidebar());
  };

  const parentHandle = (event) => {
    // alert("ddddddddd");
    // event.stopPropagation();
    dispatch(closeSidebar());
  };
  // const pathname = window.location.pathname;

  const profileName = JSON.parse(localStorage.getItem("data"));

  const handleSiteChange = (event, newValue) => {
    setSelectedSite(newValue);
  };

  return (
    <div className="header">
      <AppBar position="fixed" open={open} className="mein__header">
        <Toolbar
          sx={{
            paddingLeft: "0.5rem !important",
            paddingRight: "0.5rem !important",
          }}
        >
          <Grid container alignItems={"center"} onClick={parentHandle}>
            <Grid item xs={4} md={4} lg={4} className="logo__bg">
              <Box className="logo" display={"flex"} alignItems={"center"}>
                <div className="toggle__btn">
                  {open ? (
                    <IconButton
                      onClick={handleDrawerClose}
                      sx={{
                        marginRight: 5,
                      }}
                      className="openNav"
                    >
                      <ChevronRight />
                    </IconButton>
                  ) : (
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={handleDrawerOpen}
                      edge="start"
                      sx={{
                        marginRight: 5,
                        marginLeft: "auto",
                        ...(open && { display: "none" }),
                      }}
                    >
                      <MenuIcon />
                    </IconButton>
                  )}
                </div>

                <img
                  onClick={() => navigate("/dashboard")}
                  src={
                    profileName.companyLogoUrl &&
                    profileName.companyLogoUrl !== null
                      ? profileName.companyLogoUrl
                      : logo
                  }
                  alt="Logo"
                ></img>
              </Box>
            </Grid>
            <Grid item xs={"d-none"} md={2} lg={3}>
              <Typography variant="h6">
                {window.location.pathname === "/dashboard"
                  ? "Today’s Dashboard"
                  : ""}
              </Typography>
            </Grid>
            <Grid
              item
              xs={8}
              md={6}
              lg={5}
              textAlign={"end"}
              sx={{
                display: "flex",
                gap: "8px",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {!shouldSkipByPath && siteList && siteList?.length > 0 && (
                <Box sx={{ width: "35%" }}>
                  <CustomAutoComplete
                    options={siteList || []}
                    value={selectedSite}
                    size="small"
                    margin="dense"
                    sx={{ width: "100%" }}
                    // value={selectedSite || ""}
                    getOptionLabel={(option) =>
                      option ? option.name || option.name : ""
                    }
                    getOptionSelected={(option, value) =>
                      option.name === value.name
                    }
                    onChange={(event, newValue) => {
                      handleSiteChange(event, newValue);
                    }}
                    variant="outlined"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Site"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>
              )}
              <Box>
                <Typography
                  variant="h5"
                  className="profile"
                  // sx={{ justifyContent: `${open ? "initial" : "center"}` }}
                >
                  <Avatar
                    alt="Cindy Baker"
                    src={`${
                      profileName.userPhotoPath == null
                        ? ""
                        : profileName.userPhotoPath
                    }`}
                  />
                  {`${profileName.name}(${profileName.empCode})`}
                </Typography>
              </Box>
              <Button
                startIcon={<LogoutIcon />}
                sx={{
                  color: "var(--clr-white)",
                  fontWeight: "bold",
                  border: "2px solid #ffffff87",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#fff",
                    color: "#222",
                  },
                  transition: "all 0.3s ease-in-out",
                  textTransform: "none",
                  fontSize: "1rem",
                }}
                onClick={() => {
                  handleLogout();
                  handleDrawerClose();
                }}
              >
                Sign Out
              </Button>
              {/* <span style={{fontSize:".5rem",marginBottom:0,marginRight:"0rem"}}>{config.version}</span> */}
            </Grid>
            <Grid></Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;

// import React from "react";

// import { AppBar, Toolbar, Box, Button } from "@mui/material";
// import Logo from "../../img/Logo.png";

// import LogoutIcon from "@mui/icons-material/Logout";

// import auth from "../../route/auth";

// import { useNavigate } from "react-router-dom";
// import { setOpen, closeSidebar } from "./HeaderSlice";

// import "./Header.css";

// const Header = () => {
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     auth.logout(() => navigate("/login"));
//     localStorage.clear();
//     sessionStorage.clear();
//   };

//   return (
//     <AppBar
//       className="mein__header"
//       position="fixed"
//       sx={{
//         // height: "var(--navbar-height)",
//         display: "flex",
//         justifyContent: "center",
//         overflow: "hidden",
//         // background: "var(--clr-gradient-primary)",
//       }}
//     >
//       <Toolbar
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//         }}
//       >
//         <Box
//           component="img"
//           sx={{ height: "75%", width: "195px", cursor: "pointer" }}
//           src={Logo}
//           alt="Logo"
//           onClick={() => navigate("/dashboard")}
//         />
//         <Button
//           startIcon={<LogoutIcon />}
//           sx={{
//             color: "var(--clr-white)",
//             fontWeight: "bold",
//             "&:hover": {
//               background: "#fff",
//               color: "#222",
//             },
//             transition: "all 0.3s ease-in-out",
//             textTransform: "none",
//             fontSize: "1rem",
//           }}
//           onClick={handleLogout}
//         >
//           Sign Out
//         </Button>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Header;
